module.exports = __webpack_public_path__ + "static/media/1.ea946a14.jpeg";